export default {
  options: state => state.options,
  information: state => state.information,
  encodedCustomizable: state => state.encodedCustomizable,
  customizable: state => state.customizable,
  selectedOption: state => state.selectedOption,
  configurator: state => state.configurator,
  price: state => state.price
};